import React from 'react'; // Removed unused useRef
import { NavLink } from "react-router-dom";
import { HiUpload, HiTemplate, HiOutlineLocationMarker, HiOutlinePencilAlt, HiOutlineViewGrid, HiOutlineMap, HiShoppingCart } from "react-icons/hi"; // Added HiShoppingCart
import { useAddToCart } from '../utils/useAddToCart';
import { useTranslation } from 'react-i18next';
import { EditorPreviewRef } from '../components/EditorPreview';

interface OverviewProps {
  editorPreviewRef: React.RefObject<EditorPreviewRef | null>;
}

const Overview: React.FC<OverviewProps> = ({ editorPreviewRef }) => {
  const { t } = useTranslation(); 
  const { handleAddToCart, isAddingToCart, cartOverlay } = useAddToCart(editorPreviewRef);

  return (
    <div className="w-full mx-auto px-4 space-y-6 pb-24">
      {cartOverlay}
      <div className="space-y-1">
        <div className="font-sans font-bold text-white text-xl break-words whitespace-normal">{t('pageTitles.overview')}</div>
        <div className="mt-1 text-gray-400 font-light text-sm break-words whitespace-normal">
          {t('overviewPage.subtitle')}
        </div>
      </div>
      <div className="space-y-4">
        <NavLink
          to={"/activities"}
          className="w-full cursor-pointer flex justify-center items-center space-x-2 bg-[#333333] hover:bg-[#444444] text-white text-sm py-2 rounded-sm"
        >
          <HiUpload />
          <span>{t('overviewPage.uploadActivity')}</span>
        </NavLink>
        <NavLink
          to={"/map"}
          className="w-full cursor-pointer flex justify-center items-center space-x-2 bg-[#333333] hover:bg-[#444444] text-white text-sm py-2 rounded-sm"
        >
          <HiTemplate />
          <span>{t('overviewPage.changeTemplate')}</span>
        </NavLink>
      </div>
      <div className="space-y-4">
        <div className="text-white font-sans font-medium">
          {t('overviewPage.customizePoster')}
        </div>
        <div className="space-y-2">
          <NavLink
            to={"/points"}
            className="w-full text-sm cursor-pointer flex items-center space-x-2 py-2 px-4 rounded-sm hover:bg-[#2A2A2A]"
          >
            <HiOutlineLocationMarker className="w-5 h-5 text-gray-400" />
            <span className="text-gray-400 font-light">{t('overviewPage.addPointLink')}</span>
          </NavLink>
          <NavLink
            to={"/labels"}
            className="w-full text-sm cursor-pointer flex items-center space-x-2 py-2 px-4 rounded-sm hover:bg-[#2A2A2A]"
          >
            <HiOutlinePencilAlt className="w-5 h-5 text-gray-400" />
            <span className="text-gray-400 font-light">{t('overviewPage.addTextLink')}</span>
          </NavLink>
          <NavLink
            to={"/layout"}
            className="w-full text-sm cursor-pointer flex items-center space-x-2 py-2 px-4 rounded-sm hover:bg-[#2A2A2A]"
          >
            <HiOutlineViewGrid className="w-5 h-5 text-gray-400" />
            <span className="text-gray-400 font-light">{t('overviewPage.setLayoutLink')}</span>
          </NavLink>
          <NavLink
            to={"/map"}
            className="w-full text-sm cursor-pointer flex items-center space-x-2 py-2 px-4 rounded-sm hover:bg-[#2A2A2A]"
          >
            <HiOutlineMap className="w-5 h-5 text-gray-400" />
            <span className="text-gray-400 font-light">{t('overviewPage.setMapStyleLink')}</span>
          </NavLink>
        </div>
      </div>
      <div className="sticky bottom-0 left-0 w-full bg-[#222] pt-4 z-30">
        <button
          onClick={handleAddToCart}
          disabled={isAddingToCart}
          className="w-full text-sm cursor-pointer flex justify-center items-center space-x-2 text-white py-2 rounded-sm disabled:opacity-50 disabled:cursor-wait"
          style={{ backgroundColor: isAddingToCart ? '#FC4C02' : '#FC4C02', opacity: isAddingToCart ? 0.5 : 1 }}
          onMouseOver={e => (e.currentTarget.style.backgroundColor = '#d63a00')}
          onMouseOut={e => (e.currentTarget.style.backgroundColor = '#FC4C02')}
        >
          <HiShoppingCart className="w-4 h-4" />
          <span>{t('common.addToCart', 'Ajouter au panier')}</span>
        </button>
      </div>
    </div>
  );
};

export default Overview;